import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    campo: {
        '& input, & .MuiInputBase-input, & .MuiOutlinedInput-input': {
            textAlign: 'center',
            fontSize: '1.5rem',
            padding: '14px 18px',
            minHeight: 30,
            '&::placeholder': {
                textAlign: 'center',
            },
            '&::-webkit-input-placeholder': {
                textAlign: 'center',
            },
            '&::-moz-placeholder': {
                textAlign: 'center',
            },
            '&:-ms-input-placeholder': {
                textAlign: 'center',
            },
        }
    }
}))